// extracted by mini-css-extract-plugin
export default {"main":"b0cd26b9db","tit":"f7f7329011","maintitle":"_179465ebf1","ylw":"_0c1a1059b4","white":"_18243531e4","mv_title":"f682f123fe","mv_nc":"_956527d8d3","mv_in":"b576b30471"};